import { GET_REPORTS, GET_PROFILE, GET_REPORT_TYPES } from "./types";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import { push } from "connected-react-router";
export const getReports = () => {
    return (dispatch) => {
        dispatch({ type: GET_REPORTS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/users/`)
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_REPORTS.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                } else {
                    dispatch({ type: GET_REPORTS.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_REPORTS.FAIL });
        }
    };
};
export const redirectTo = (link) => {
    return (dispatch) => {
        dispatch(push(link));
    };
};
export const getProfile = () => {
    return (dispatch) => {
        dispatch({ type: GET_PROFILE.REQUEST });

        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/users/${user.uid}`)
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_PROFILE.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                } else {
                    dispatch({ type: GET_PROFILE.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_PROFILE.FAIL });
        }
    };
};
export const getReportTypes = () => {
    return (dispatch) => {
        dispatch({ type: GET_REPORT_TYPES.REQUEST });

        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/collections/report_titles`)
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_REPORT_TYPES.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                } else {
                    dispatch({ type: GET_REPORT_TYPES.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_REPORT_TYPES.FAIL });
        }
    };
};
